module.exports = __webpack_public_path__ + "img/money.37726c36.svg";